import { render } from "./NeoAbout.vue?vue&type=template&id=13381a94"
import script from "./NeoAbout.vue?vue&type=script&lang=js"
export * from "./NeoAbout.vue?vue&type=script&lang=js"

import "./NeoAbout.vue?vue&type=style&index=0&id=13381a94&lang=scss"

import exportComponent from "/var/www/html/neo-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__